// ====== 배치 작업 타입 ======
// 백엔드 BatchJobType enum(com.ibj.alttext_be.entity.BatchJobType)과 1:1 대응
export type BatchJobType =
  | 'WITHDRAWAL_AUTO_DELETE'         // 탈퇴 회원 자동 삭제
  | 'WITHDRAWAL_LOG_CLEANUP'         // 탈퇴 로그 정리
  | 'PASSWORD_RESET_TOKEN_CLEANUP'   // 만료 토큰 정리
  | 'SESSION_CLEANUP'                // 만료 세션 정리
  | 'ALT_TEXT_GENERATION'            // ALT 텍스트 자동 생성
  | 'UPGRADE_TIMEOUT_CLEANUP'        // 업그레이드 24시간 타임아웃 정리
  | 'ENTERPRISE_CONTRACT_RENEWAL'    // 엔터프라이즈 계약 갱신
  | 'ENTERPRISE_DOWNGRADE'           // 엔터프라이즈 다운그레이드
  | 'ENTERPRISE_RECURRING_PAYMENT'   // 엔터프라이즈 정기 결제
  | 'RECURRING_PAYMENT'              // 일반 플랜 정기 결제(개인)
  | 'TEAM_RECURRING_PAYMENT'         // 일반 플랜 정기 결제(팀)
  | 'PLAN_CHANGE'                    // 일반 플랜 다운그레이드
  | 'PAYMENT_REMINDER'               // 결제 예정 알림
  | 'PENDING_PAYMENT_CANCELLATION'   // 입금 대기 결제 자동 취소
  | 'TEAM_MEMBER_REMOVAL_CLEANUP'    // 팀 탈퇴 예약 정리
  | 'BATCH_HISTORY_CLEANUP'          // 배치 이력 정리
  | 'SPRING_BATCH_METADATA_CLEANUP'  // Spring Batch 메타데이터 정리
  | 'WORKSPACE_DUNNING_GRACE_PERIOD_EXPIRE' // 워크스페이스 유예기간 만료 처리
  | 'WORKSPACE_RECURRING_BILLING'    // 워크스페이스 정기결제(월간 일괄)
  | 'WORKSPACE_SAME_DAY_RETRY'       // 워크스페이스 정기결제 당일 재시도
  | 'WORKSPACE_MEMBER_ORPHAN_SCAN'   // 워크스페이스 멤버십 orphan 스캔
  | 'RECURRING_BILLING_DOUBLE_CHARGE_SCAN' // 정기결제 이중청구 탐지 스캔
  | 'WORKSPACE_BANK_TRANSFER_OVERDUE_CANCEL' // 워크스페이스 계좌이체 정기결제 자동취소
  | 'WORKSPACE_DUNNING_RETRY_CHARGE'  // 워크스페이스 던닝 재시도 청구
  | 'WORKSPACE_PAST_DUE_STATUS_BACKFILL'; // 워크스페이스 미납 상태 재적용(1회성 정리)

// 배치 타입별 한글명 매핑
export const BATCH_JOB_NAMES: Record<string, string> = {
  WITHDRAWAL_AUTO_DELETE: '탈퇴 회원 자동 삭제',
  WITHDRAWAL_LOG_CLEANUP: '탈퇴 로그 정리',
  PASSWORD_RESET_TOKEN_CLEANUP: '만료 토큰 정리',
  SESSION_CLEANUP: '만료 세션 정리',
  ALT_TEXT_GENERATION: 'ALT 텍스트 자동 생성',
  UPGRADE_TIMEOUT_CLEANUP: '업그레이드 타임아웃 정리',
  ENTERPRISE_CONTRACT_RENEWAL: '엔터프라이즈 계약 갱신',
  ENTERPRISE_DOWNGRADE: '엔터프라이즈 다운그레이드',
  ENTERPRISE_RECURRING_PAYMENT: '엔터프라이즈 정기 결제',
  RECURRING_PAYMENT: '일반 플랜 정기 결제(개인)',
  TEAM_RECURRING_PAYMENT: '일반 플랜 정기 결제(팀)',
  PLAN_CHANGE: '일반 플랜 다운그레이드',
  PAYMENT_REMINDER: '결제 예정 알림',
  PENDING_PAYMENT_CANCELLATION: '입금 대기 결제 자동 취소',
  TEAM_MEMBER_REMOVAL_CLEANUP: '팀 탈퇴 예약 정리',
  BATCH_HISTORY_CLEANUP: '배치 이력 정리',
  SPRING_BATCH_METADATA_CLEANUP: 'Spring Batch 메타데이터 정리',
  WORKSPACE_DUNNING_GRACE_PERIOD_EXPIRE: '워크스페이스 유예기간 만료 처리',
  WORKSPACE_RECURRING_BILLING: '워크스페이스 정기결제(월간 일괄)',
  WORKSPACE_SAME_DAY_RETRY: '워크스페이스 정기결제 당일 재시도',
  WORKSPACE_MEMBER_ORPHAN_SCAN: '워크스페이스 멤버십 orphan 스캔',
  RECURRING_BILLING_DOUBLE_CHARGE_SCAN: '정기결제 이중청구 탐지 스캔',
  WORKSPACE_BANK_TRANSFER_OVERDUE_CANCEL: '워크스페이스 계좌이체 정기결제 자동취소',
  WORKSPACE_DUNNING_RETRY_CHARGE: '워크스페이스 던닝 재시도 청구',
  WORKSPACE_PAST_DUE_STATUS_BACKFILL: '워크스페이스 미납 상태 재적용(1회성 정리)'
};

// ====== 실행 상태 ======
export type BatchExecutionStatus = 
  | 'RUNNING'           // 실행 중
  | 'SUCCESS'           // 성공
  | 'FAILED'            // 실패
  | 'PARTIAL_SUCCESS'   // 부분 성공
  | 'NEVER_EXECUTED';   // 미실행

// 상태별 아이콘
export const STATUS_ICONS: Record<BatchExecutionStatus, string> = {
  RUNNING: '⏳',
  SUCCESS: '✅',
  FAILED: '❌',
  PARTIAL_SUCCESS: '⚠️',
  NEVER_EXECUTED: '⏸️'
};

// 상태별 색상 클래스
export const STATUS_COLORS: Record<BatchExecutionStatus, string> = {
  RUNNING: 'blue',
  SUCCESS: 'green',
  FAILED: 'red',
  PARTIAL_SUCCESS: 'orange',
  NEVER_EXECUTED: 'gray'
};

// 상태별 한글명
export const STATUS_NAMES: Record<BatchExecutionStatus, string> = {
  RUNNING: '실행 중',
  SUCCESS: '성공',
  FAILED: '실패',
  PARTIAL_SUCCESS: '부분 성공',
  NEVER_EXECUTED: '미실행'
};

// ====== API 응답 인터페이스 ======
export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
  totalElements?: number;
  totalPages?: number;
  currentPage?: number;
  pageSize?: number;
}

// ====== 배치 작업 정보 ======
export interface BatchJob {
  jobType: BatchJobType;
  displayName: string;
  scheduleDescription: string;
  cronExpression: string;
  lastExecutionStatus: BatchExecutionStatus;
  lastExecutionTime: string | null;
  lastExecutionDuration: number | null;
  lastExecutionResult: string | null;
  successRate30Days: number | null;
  avgDuration30Days: number | null;
}

// ====== 배치 실행 이력 ======
export interface BatchExecutionHistory {
  id: number;
  jobType: BatchJobType;
  status: BatchExecutionStatus;
  startedAt: string;
  finishedAt: string | null;
  durationMs: number | null;
  totalCount: number;
  successCount: number;
  failedCount: number;
  resultMessage: string | null;
  errorMessage: string | null;
  errorStackTrace: string | null;
  isManualExecution: boolean;
  executedBy: string | null;
  createdAt: string;
}

// ====== 배치 개별 건(대상 계정) 실행 이력 ======
export interface BatchItemExecutionHistory {
  id: number;
  batchExecutionHistoryId: number;
  entityType: string | null;       // USER, TEAM, CONTRACT 등
  entityId: string | null;         // userId, teamId, contractId 등
  itemType: string | null;         // DOWNGRADE, PAYMENT, PLAN_CHANGE, RENEWAL, UPGRADE_TIMEOUT 등
  itemId: string | null;
  scheduledJobName: string | null;
  status: BatchExecutionStatus;
  executionTime: string;
  durationMs: number | null;
  errorMessage: string | null;
  errorType: string | null;
  errorDetails: string | null;
  beforeState: string | null;      // JSON 문자열
  afterState: string | null;       // JSON 문자열
  changedFields: string | null;    // JSON 문자열 (필드명 배열)
  amount: number | null;
  plan: string | null;
  effectiveDate: string | null;
  retryCount: number | null;
  billingMonth: string | null;
  notificationSent: boolean;
  processedBy: string | null;
  notes: string | null;
  resolved: boolean;
  resolvedAt: string | null;
  resolvedBy: string | null;
  createdAt: string;
}

// ====== 배치 통계 ======
export interface BatchStatistics {
  totalExecutions: number;
  successCount: number;
  failedCount: number;
  partialSuccessCount: number;
  successRate: number;
  executionCountByJob: Record<BatchJobType, number>;
  successRateByJob: Record<BatchJobType, number>;
}

// ====== 배치 설정 관리 (신규) ======
export interface BatchJobConfig {
  id: number;
  jobType: string;
  displayName: string;
  description: string | null;
  cronExpression: string;
  scheduleDescription: string;
  isActive: boolean;
  isAllowConcurrent: boolean;
  timeoutMinutes: number;
  notificationEmails: string[];
  createdAt: string;
  updatedAt: string | null;
}

export interface BatchJobConfigFormData {
  jobType: string;
  displayName: string;
  description: string;
  cronExpression: string;
  scheduleDescription: string;
  isActive: boolean;
  isAllowConcurrent: boolean;
  timeoutMinutes: number;
  notificationEmails: string[];
}
